import { useLiveQuery } from "dexie-react-hooks";
import React from "react";
import { useSystemwideData } from "../../api/seedData";
import { mapDB } from "../../store/mapStore";
import { MetricsTable } from "./MetricsTable";

interface MetricsTableWrapper {
  mobile: boolean;
}

export const MetricsTableWrapper: React.FC<MetricsTableWrapper> = ({
  mobile,
}) => {
  const systemData = useSystemwideData();

  const selectedSchool = useLiveQuery(() =>
    mapDB.selectedSchool.where("active").equals(1).toArray(),
  );
  const school = selectedSchool?.[0];
  const data = school ? school.school_data.scenarios : systemData;
  delete school?.school_data?.scenarios?.[2];

  if (!data) return null;
  return (
    <MetricsTable
      data={data}
      system={school === undefined}
      mobile={mobile}
      school={school}
    />
  );
};
